import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const newsDetailsData = createAsyncThunk(
  "getnewsDetailsData",
  async (match_id) => {
    try {
      // var { data } = await axios({
      //   method: "post",
      //   url: "https://api.cricway.live/api/v1/cms/getNewsDetail/asjgs55463",
      //   data: {
      //     param: match_id,
      //   },
      //   headers: {
      //     "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      //   },
      // });

      const {
        data: { data },
      } = await axios.get(
        "https://apicricketchampion.in/apiv4/news/d19aeb221511ee5998a0c908beced23a"
      );

      const newsData = data.find(({ news_id }) => news_id === Number(match_id));

      return newsData;
    } catch (err) {
      return err;
    }
  }
);

const newsDetailsSlice = createSlice({
  name: "newsDetails",
  initialState: {
    data: [],
    pending: false,
    error: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(newsDetailsData.pending, (state) => {
        state.pending = true;
      })
      .addCase(newsDetailsData.fulfilled, (state, action) => {
        state.pending = false;
        console.log("action.payload", action.payload);

        state.data = action.payload;
        state.error = false;
      })
      .addCase(newsDetailsData.rejected, (state, action) => {
        state.pending = false;
        state.data = [];
        state.error = action.error.message;
      });
  },
});

export default newsDetailsSlice.reducer;
